import { useState } from "react";
import { Link } from "react-router-dom";
import { api, COMPANY_LOGO } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowLeft, ShieldCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Talep gönderilemedi. Lütfen tekrar deneyin.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 dark:bg-slate-950 p-4">
      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl shadow-xl p-8">
        <div className="flex items-center gap-3 mb-6">
          <img src={COMPANY_LOGO} alt="" className="w-10 h-10 object-contain" />
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">Hesap Kurtarma</div>
            <div className="font-display text-xl font-extrabold text-slate-900 dark:text-slate-100">Şifremi Unuttum</div>
          </div>
        </div>

        {!sent ? (
          <>
            <p className="text-sm text-slate-600 dark:text-slate-300 mb-6">
              Kayıtlı e-postanızı girin. Yöneticiniz size sıfırlama bağlantısını iletsin diye
              talebiniz sisteme kaydedilecek.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs uppercase font-bold text-slate-500 tracking-widest">E-posta</label>
                <div className="relative">
                  <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                  <input type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email"
                    placeholder="ozkan@madymark.com"
                    className="w-full mt-1 pl-9 pr-3 py-2.5 border border-slate-300 dark:border-slate-600 rounded-lg dark:bg-slate-800 dark:text-slate-100 focus:ring-2 focus:ring-[#1E2A9C]/30 outline-none" />
                </div>
              </div>
              <button type="submit" disabled={busy} data-testid="forgot-submit"
                className="w-full py-3 rounded-lg bg-[#1E2A9C] text-white font-bold hover:bg-[#121A68] disabled:opacity-60 transition">
                {busy ? "Gönderiliyor..." : "Sıfırlama Talebi Gönder"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-4" data-testid="forgot-sent">
            <div className="w-16 h-16 mx-auto rounded-full bg-emerald-100 grid place-items-center mb-4">
              <ShieldCheck className="w-8 h-8 text-emerald-600" />
            </div>
            <div className="font-display text-lg font-extrabold text-slate-900 dark:text-slate-100 mb-2">Talebiniz Alındı</div>
            <p className="text-sm text-slate-600 dark:text-slate-300">
              Yöneticiniz kısa süre içinde sizinle iletişime geçerek şifre sıfırlama bağlantısını iletecek.
            </p>
            <p className="text-xs text-slate-500 mt-4">
              Bağlantıyı aldığınızda tarayıcıda açıp yeni şifrenizi belirleyebilirsiniz.
            </p>
          </div>
        )}

        <div className="mt-6 pt-6 border-t border-slate-100 dark:border-slate-800 text-center">
          <Link to="/login" data-testid="link-back-login"
            className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-[#1E2A9C] font-bold">
            <ArrowLeft className="w-3 h-3" /> Girişe Dön
          </Link>
        </div>
      </div>
    </div>
  );
}
